enum ThresholdType {
  Default = 'default',
  EventType = 'event_type',
}

export { ThresholdType };
